// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"474":"4090afd0","730":"5199bb02","739":"e60eddd8"}[chunkId] + ".chunk.css";
};